import { giphyBlack } from '@giphy/colors'
import { useContext, useEffect, useState } from 'react'
import DotsLoader from 'shared/components/loaders/dots'
import MessageContext from 'shared/contexts/message'
import UserContext from 'shared/contexts/user'
import CreationToolFont from 'site/creation-tools/types/font'
import styled from 'styled-components'
import { useAsyncEffect } from 'utils'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import SelectList from '../../select-list'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'
import API from '../../supercut/shared/utils/api'
import FieldTitle from './field-title'

const api = new API()

const Container = styled.div`
    grid-column: span 1;
    min-width: 0;
    position: relative;
`
const UploadNew = styled.div`
    cursor: pointer;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureFontField = ({ field }: Props) => {
    const { font, setFont, previousFonts, setPreviousFonts, setIsCustomFontOpen, captionStyle, setCaptionStyle } =
        useContext(CreationCaptureInfoContext)
    const { sendMessage } = useContext(MessageContext)
    const [isLoading, setIsLoading] = useState<Boolean>(false)
    const { user } = useContext(UserContext)

    useAsyncEffect(async () => {
        // Fetch all previous fonts this user has uploaded.
        setIsLoading(true)
        try {
            const fonts = await api.getFonts(user.username)
            setPreviousFonts(fonts)
        } catch (error) {
            setPreviousFonts([])
            sendMessage(`Unable to load previously used fonts. Please refresh and try again.`, 'error')
        }
        setIsLoading(false)
    }, [])

    useEffect(() => {
        const loadAllFontsIntoDOM = async () => {
            previousFonts.forEach(async (font) => {
                const fontFace = new FontFace(`uploadedFont-${font.filename}`, `url(${font.fontUrl})`)
                // @ts-ignore
                document.fonts.add(fontFace)
                await fontFace.load()
            })
        }

        loadAllFontsIntoDOM()
    }, [previousFonts])

    const onChange = (val: string) => {
        if (font?.id === val) {
            setFont()
            setCaptionStyle({
                ...captionStyle,
                font: CreationToolFont.Giphy,
            })
        } else {
            const selectedIndex = previousFonts.findIndex((fnt) => fnt.id === val)
            setFont(previousFonts[selectedIndex])
            setCaptionStyle({
                ...captionStyle,
                font: CreationToolFont.Custom,
            })
        }
    }

    return (
        <Container>
            <FieldTitle field={field} />
            {isLoading ? (
                <DotsLoader isAbsolute={true} />
            ) : (
                <SelectList
                    {...{
                        onChange,
                        popUpColor: giphyBlack,
                        value: font?.id,
                        options: previousFonts.map((f) => ({
                            value: f.id,
                            label: <span style={{ fontFamily: `"uploadedFont-${f.filename}"` }}>{f.filename}</span>,
                        })),
                    }}
                >
                    <UploadNew onClick={() => setIsCustomFontOpen(true)}>Upload New</UploadNew>
                    <UploadNew onClick={() => setIsCustomFontOpen(true)}>See All</UploadNew>
                </SelectList>
            )}
        </Container>
    )
}

export default CreationCaptureFontField
